module.exports = __webpack_public_path__ + "static/media/waterfalls.8f82737b.svg";